import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=38a4e438&lang=scss&scoped=true"

import exportComponent from "/Users/pipiguainb/Project/ZHWAPPREALVERSION/zhaohaowan-IM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a4e438"]])

export default __exports__